import sa from "superagent";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

export const VimeoEmbed = ({ url }) => {
  const [embedInfo, setEmbedInfo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    sa.get(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`)
      .then(({ body }) => {
        console.log(body);
        setEmbedInfo(body);
        setError(null);
      })
      .catch((err) => {
        console.log(`Error while fetching vimeo embed ${err}`);
        setError("Unable to fetch embed info");
        setEmbedInfo(null);
      });
    return () => {};
  }, [url]);

  if (error) {
    return <p>{error}</p>;
  } else if (embedInfo) {
    return <div dangerouslySetInnerHTML={{ __html: embedInfo.html }} />;
  } else {
    return <p>Loading...</p>;
  }
};

VimeoEmbed.propTypes = {
  url: PropTypes.string,
};

export default VimeoEmbed;
